import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { PersonWithCuitResponse, PersonWithDniResponse } from '../models/person-response.model';

@Injectable({
    providedIn: 'root'
})
export class PersonService {

    constructor(private http: HttpClient) { }

    getPersonByCUIT(doumentId: string): Observable<PersonWithCuitResponse> {
        return this.http.get(`${environment.server.api.contactManager}/api/person/cuit?DocumentNumber=${doumentId}`).pipe(
            map((response: { data: PersonWithCuitResponse }) => response && response.data),
        );
    }

    getPersonsByCUIT(data: string[]): Observable<PersonWithCuitResponse[]> {
        return this.http.post<PersonWithCuitResponse[]>(`${environment.server.api.contactManager}/api/person/PersonsByCuit`, data);
    }

    personsByDni(data: string[]): Observable<PersonWithDniResponse[]> {
        return this.http.post<PersonWithDniResponse[]>(`${environment.server.api.contactManager}/api/person/PersonsByDni`, data);
    }
}
